import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';
import * as fromItems from './reducer';

export const getItemState = createFeatureSelector<State>('item');

export const getItems = createSelector(
  getItemState,
  (state: State) => fromItems.selectAll(state)
);

export const getPageNum = createSelector(
  getItemState,
  (state: State) => state.pageNum
);

export const getFilterSortData = createSelector(
  getItemState,
  (state: State) => state.filterSortData
);

export const getTotalItems = createSelector(
  getItemState,
  (state: State) => state.totalItems
);

export const getPaginationData = createSelector(
  getTotalItems,
  getItemState,
  (totalItems, state) => ({ totalItems, totalPages: Math.ceil( totalItems / 100), pageNumber: state.pageNum })
);

export const getFiltersData = createSelector(
  getItemState,
  (state: State) => state.filterSortData.filter
);

export const getCheckedItems = createSelector(
  getItemState,
  (state: State) => state.checkedItems
);

export const getSelectedItem = createSelector(
  getItemState,
  (state: State) => state.selectedItem
);

export const getProjectId = createSelector(
  getItemState,
  (state: State) => state.projectId
);

export const getAllowAddNewItem = createSelector(
  getItemState,
  (state: State) => state.allowAddNewItem
);

export const getIsRefreshing = createSelector(
  getItemState,
  (state: State) => state.isRefreshing
);

export const getParamsToFetchItems = createSelector(
  getProjectId,
  getPageNum,
  getFilterSortData,
  (projectId, pageNum, filterSortData) => ({ projectId, pageNum, filterSortData})
);

export const getIsLoading = createSelector(
  getItemState,
  (state: State) => state.isLoading
);



